export default __webpack_public_path__ + "static/media/Formular.8e0d9e35.woff2";